import React, { useEffect } from 'react';
import { Controller, Control } from 'react-hook-form';
import PhoneInput from './PhoneInput';

export interface PhoneInputFieldProps {
  name: string;
  control: Control<any>;
  rules?: any;
  helperText?: string;
  defaultValue?: string;
  // Phone Input specific props
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  country?: string;
  preferredCountries?: string[];
  enableAreaCodes?: boolean;
  enableSearch?: boolean;
  excludeCountries?: string[];
  onlyCountries?: string[];
  autoFormat?: boolean;
  disableCountrySelect?: boolean;
  variant?: string;
  size?: string;
  // Optional callbacks
  onPhoneChange?: (value: string, country: any) => void;
  onPhoneBlur?: () => void;
  onCountryChange?: (country: string) => void;
}

function PhoneInputField({
  name,
  control,
  rules,
  helperText,
  defaultValue = '',
  onPhoneChange,
  onPhoneBlur,
  onCountryChange,
  ...phoneInputProps
}: PhoneInputFieldProps) {
  // Handle country changes
  useEffect(() => {
    if (onCountryChange && phoneInputProps.country) {
      onCountryChange(phoneInputProps.country);
    }
  }, [phoneInputProps.country, onCountryChange]);
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
        <PhoneInput
          {...phoneInputProps}
          name={name}
          value={value || ''}
          onChange={(phoneValue, country) => {
            onChange(phoneValue);
            // If parent component wants to handle country change
            if (onPhoneChange) {
              onPhoneChange(phoneValue, country);
            }
          }}
          onBlur={() => {
            onBlur();
            if (onPhoneBlur) {
              onPhoneBlur();
            }
          }}
          error={!!error}
          helperText={error?.message || helperText}
          disableCountrySelect={phoneInputProps.disableCountrySelect}
          variant={phoneInputProps.variant}
          size={phoneInputProps.size}
        />
      )}
    />
  );
}

PhoneInputField.displayName = 'PhoneInputField';

export default PhoneInputField; 